import { render, staticRenderFns } from "./PerformanceDetails.vue?vue&type=template&id=5a9bdc90"
import script from "./PerformanceDetails.vue?vue&type=script&lang=js"
export * from "./PerformanceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports